import React from "react";
import {
  ScrollArea,
  Flex,
  Box,
  Text,
  Badge,
  ThemeIcon,
  NumberFormatter,
} from "@mantine/core";
import { IconCheck, IconDevicesPc } from "@tabler/icons-react";

interface VoucherListProps {
  dataVoucher: any[]; // Kiểu dữ liệu của danh sách voucher
  selectedPromotion: any | null;
  handleOptionChange: (voucher: any) => void;
  peach: { base: string };
  orange: { vivid: string };
  isWholesale?: boolean;
}

const VoucherList: React.FC<VoucherListProps> = ({
  dataVoucher,
  selectedPromotion,
  handleOptionChange,
  peach,
  orange,
  isWholesale,
}) => {
  return (
    <ScrollArea h={530}>
      <Text size="md" fw={700} mb="xs">
        Chọn chính sách khuyến mãi:
      </Text>

      <Flex gap={12} direction={"column"} pb={15}>
        {dataVoucher?.map((voucher) => {
          const isSelected = Boolean(
            selectedPromotion &&
              (selectedPromotion?.tblPromotion?.id ===
                voucher?.tblPromotion?.id ||
                selectedPromotion === voucher)
          );

          return (
            <Flex
              align={"center"}
              onClick={() => handleOptionChange(voucher)}
              className="voucher-card"
              key={voucher.tblPromotion.id}
              style={{
                cursor: "pointer",
                position: "relative",
                border: isSelected ? "2px solid #20c997" : "1px dashed #ced4da",
                backgroundColor: isSelected ? "#f0fdf4" : "#ffffff",
                boxShadow: isSelected
                  ? "0 4px 12px rgba(32, 201, 151, 0.25)"
                  : "0 1px 3px rgba(0, 0, 0, 0.05)",
                transition: "all 0.2s ease-in-out",
                opacity: !isSelected && isWholesale ? 0.75 : 1,
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              {/* Badge trạng thái ở góc trên bên phải */}
              <Box style={{ position: "absolute", top: 6, right: 8, zIndex: 2 }}>
                {isSelected ? (
                  <Badge color="teal" variant="filled" size="xs">
                    Đang chọn
                  </Badge>
                ) : isWholesale ? (
                  <Badge color="gray" variant="light" size="xs">
                    Đã bỏ chọn
                  </Badge>
                ) : null}
              </Box>

              <Flex
                justify={"center"}
                align={"center"}
                w={"28%"}
                bg={isSelected ? orange.vivid : peach.base}
                direction={"column"}
                py={12}
                style={{ transition: "background-color 0.2s" }}
              >
                <Box
                  style={{
                    borderRadius: "50%",
                    backgroundColor: isSelected ? "#e8590c" : orange.vivid,
                    padding: 5,
                    color: "white",
                  }}
                >
                  <IconDevicesPc size={42} />
                </Box>
                <Text c={"white"} fw={600} size="sm">
                  Điện tử
                </Text>
              </Flex>

              <Box w={"58%"} p={10}>
                <Text
                  fw={700}
                  style={{ fontSize: 15 }}
                  c={isSelected ? "teal.8" : undefined}
                >
                  {voucher.tblPromotion.code}
                </Text>
                <Text c={"#888888"} size="xs" lineClamp={2}>
                  {voucher.tblPromotion.note}
                </Text>
                <Text size="sm" mt={2}>
                  {voucher.tblPromotionItemPrimary[0]?.discountPrice > 0 ? (
                    <>
                      Giá tiền trong CTKM:{" "}
                      <NumberFormatter
                        value={voucher.tblPromotionItemPrimary[0]?.discountPrice}
                        thousandSeparator="."
                        decimalSeparator=","
                        suffix="₫"
                      />
                    </>
                  ) : (
                    <>
                      Giảm{" "}
                      {voucher.tblPromotionItemPrimary[0]?.discountPercent ? (
                        <Text span fw={700} c="red">
                          {voucher.tblPromotionItemPrimary[0]?.discountPercent}%
                        </Text>
                      ) : (
                        <NumberFormatter
                          value={
                            voucher.tblPromotionItemPrimary[0]?.discountAmount ||
                            0
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                          suffix="₫"
                        />
                      )}
                    </>
                  )}
                </Text>
                {/* Thêm giá trị max và min */}
                <Text c={"#666666"} size="xs" mt={2}>
                  Áp dụng SL từ{" "}
                  <NumberFormatter
                    value={voucher.tblPromotionItemPrimary[0]?.min || 0}
                  />{" "}
                  đến{" "}
                  {voucher.tblPromotionItemPrimary[0]?.max === 0 ? (
                    "Không giới hạn"
                  ) : (
                    <NumberFormatter
                      value={voucher.tblPromotionItemPrimary[0]?.max || 0}
                    />
                  )}
                </Text>
              </Box>

              {/* Nút tích xanh / vòng tròn rỗng phân biệt rõ ràng */}
              <Box
                w={"14%"}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {isSelected ? (
                  <ThemeIcon color="teal" size={26} radius="xl" variant="filled">
                    <IconCheck size={16} stroke={3} />
                  </ThemeIcon>
                ) : (
                  <Box
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      border: "2px solid #adb5bd",
                      backgroundColor: "#fff",
                      transition: "all 0.2s ease",
                    }}
                  />
                )}
              </Box>
            </Flex>
          );
        })}

        {dataVoucher?.length < 1 && <Text>Không có chính sách khuyến mãi</Text>}
      </Flex>
    </ScrollArea>
  );
};

export default VoucherList;
